import { Box, Flex } from '@chakra-ui/react';
import { useMODataContext } from 'src/features/MO/contexts/MODataContext';

export const OptimizationHeader: React.FC = () => {
  const { marginPct } = useMODataContext();

  return (
    <Flex
      fontWeight="bold"
      textAlign={{ lg: 'right', xl: 'left' }}
      whiteSpace="nowrap"
      bg="surface.sidebarMuted"
      flexDir="row"
      wrap="nowrap"
      minW="fit-content">
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="15%"
        minW="140px"
        p={4}>
        Optimization name
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="20%"
        minW="180px"
        p={4}>
        Period
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="15%"
        minW="110px"
        p={4}>
        Investment
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="15%"
        minW="110px"
        p={4}>
        Media Effect
      </Box>
      {marginPct !== null && (
        <Box
          fontSize={{ md: 'xs', lg: 'sm' }}
          textAlign={{ lg: 'right', xl: 'left' }}
          fontWeight="medium"
          fontFamily="marketingPage"
          color="content.muted"
          width={{ base: '50%', md: '10%' }}
          minW={{ base: '60px', md: 'auto' }}
          p={4}>
          ROMI
        </Box>
      )}
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="10%"
        minW="80px"
        p={4}>
        ROI
      </Box>
      <Box
        fontSize={{ md: 'xs', lg: 'sm' }}
        textAlign={{ lg: 'right', xl: 'left' }}
        fontWeight="medium"
        fontFamily="marketingPage"
        color="content.muted"
        width="10%"
        minW="120px"
        p={4}>
        Constraint count
      </Box>
    </Flex>
  );
};
